import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Role } from '@core/enums';
import { Position } from '@core/enums/position';
import { TranslateModule } from '@ngx-translate/core';
import { InlineSVGModule } from 'ng-inline-svg-2';

@Component({
    selector: 'lib-verified-by-smooved',
    standalone: true,
    imports: [InlineSVGModule, TranslateModule],
    template: `
        <div
            class="flex items-center flex-nowrap tooltip"
            [class.align-right]="aligned === Position.Right"
            [attr.data-tip]="'V2.VERIFIED_BY_SMOOVED_TOOLTIP' | translate"
        >
            @if (!onlyIcon) {
                <span class="text-secondary text-xs">{{ 'V2.VERIFIED_BY_SMOOVED' | translate }}</span>
            }
            @switch (role) {
                @case (Role.Mover) {
                    <div
                        [class.ml-1]="positioned === Position.Right"
                        [class.mr-1]="positioned === Position.Left"
                        [inlineSVG]="'https://assets.smooved.be/icons/v2/16/verified.svg'"
                    ></div>
                }
                @case (Role.RealEstateAgent) {
                    <div
                        [class.ml-1]="positioned === Position.Right"
                        [class.mr-1]="positioned === Position.Left"
                        [inlineSVG]="'https://assets.smooved.be/icons/verified-rea.svg'"
                    ></div>
                }
            }
        </div>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VerifiedBySmoovedComponent {
    @Input() public onlyIcon = false;
    @Input() public role: Role;
    @Input() public positioned: Position = Position.Right;
    @Input() public aligned: Position;

    protected readonly Role = Role;
    protected readonly Position = Position;
}
